import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { ListProject, DeleterProject, ListCategoryClient, deletecategoryClient, ListTodo, deleteTodo } from '../../../../Utility/Api';  // Import your API functions
import { TodoForm, ClientForm } from './form';
import { Deletemodel } from "../../../Common/Functions";
import "../project.css"
import "./Todo.css"
import { NaviGate } from '../../../../Utility/function';


const Todolist = () => {

  const [Todo, setTodo] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showcategoryModal, setShowcategoryModal] = useState(false);
  const [deleteModal, showDeleteModal] = useState(false);
  const [deleteID, setDeleteID] = useState("");

  const BASE_URL = `http://193.203.162.101:8002`;
  const [deleteCategoryModal, showDeleteCategoryModal] = useState(false);
  const [deletecategoryID, setDeletecategoryID] = useState("");

  const [selectedUnit, setSelectedUnit] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null)
  const [currentPage, setCurrentPage] = useState(1);
  const unitsPerPage = 10;
  const [Category, setCategory] = useState([]);

  const [Tablename, setTablename] = useState(2);

  useEffect(() => {
    fetchTodos();
    fetchCategory();
  }, []);

  const fetchTodos = async () => {
    try {
      const response = await ListTodo();
      if (response.data && response.data.data) {
        setTodo(response.data.data);
        console.log("project", response.data.data)
      } else {
        toast.error('No units found.');
      }
    } catch (error) {
      console.error('Error fetching units:', error);
      toast.error('Error fetching units');
    }
  };


  const fetchCategory = async () => {
    try {
      const response = await ListCategoryClient();
      if (response.data && response.data.data) {
        setCategory(response.data.data);
        console.log("project", response.data.data)
      } else {
        toast.error('No units found.');
      }
    } catch (error) {
      console.error('Error fetching units:', error);
      toast.error('Error fetching units');
    }
  };


  const openModal = (unit = null) => {
    setSelectedUnit(unit);
    setShowModal(true);
  };



  const openCategoryModal = (unit = null) => {
    setSelectedCategory(unit);
    setShowcategoryModal(true);

  };



  const handleDelete = async () => {
    try {
      await deleteTodo(deleteID);
      showDeleteModal(false);
      toast.success('Todo deleted successfully');
      fetchTodos();
    } catch (error) {
      console.error('Error deleting unit:', error);
      // toast.error('Error deleting unit');
    }
  };


  const handleCategoryDelete = async () => {
    try {
      await deletecategoryClient(deletecategoryID);
      toast.success('Category deleted successfully');
      fetchCategory();
      showDeleteCategoryModal(false);
    } catch (error) {
      console.error('Error deleting unit:', error);
      toast.error('Error deleting unit');
    }
  };


  const handleDeleteModal = (ID) => {
    showDeleteModal(true);
    setDeleteID(ID);
  };


  const handleDeleteCategoryModal = (ID) => {
    showDeleteCategoryModal(true);
    setDeletecategoryID(ID);
  };


  const handleImageError = (event) => {
    event.target.src = `/images/imageplaceholder.jpeg`; // Path to your default image
  };

  const handleUserImageError = (event) => {
    event.target.src = '/images/add-user1.png';
  };

  const handleProImageError = (event) => {
    event.target.src = `/images/images1.png`; // Path to your default image
  };

  const indexOfLastUnit = currentPage * unitsPerPage;
  const indexOfFirstUnit = indexOfLastUnit - unitsPerPage;
  const currentProject = Todo.slice(indexOfFirstUnit, indexOfLastUnit);
  const totalPages = Math.ceil(Todo.length / unitsPerPage);

  //   const handlePageChange = (pageNumber) => {
  //     setCurrentPage(pageNumber);
  //   };

  return (
    <div className="page-wrappers">

      <div className="page-content">
        <NaviGate />
        <div className="mb-0 d-flex justify-content-between align-items-center">
          <h6 className="mb-0 text-uppercase">{Tablename == 1 ? "Todo List" : "Category"}</h6>
          {Tablename == 1 ?
            <button
              type="button"
              onClick={() => { openModal() }}
              className="btn btn-primary mb-2"
              style={{ fontFamily: "Poppins" }}
            >
              Add Todo
            </button>
            :

            <button
              type="button"
              onClick={() => { openCategoryModal() }}
              className="btn btn-primary mb-2"
              style={{ fontFamily: "Poppins" }}
            >
              Add Category
            </button>
          }
        </div>
        <hr className="mt-1" />


        {Tablename != 1 ?
          <div className="card">
            <div className="text-center mt-3 mb-3" style={{ display: "flex", justifyContent: "center", gap: "30px" }}>
              <h6
                onClick={() => setTablename(2)}
                style={{
                  borderBottom: Tablename === 2 ? "3px solid blue" : "none",
                  cursor: "pointer",
                  paddingBottom: "5px"
                }}
              >
                Category
              </h6>

              <h6
                onClick={() => setTablename(1)}
                style={{
                  borderBottom: Tablename === 1 ? "3px solid blue" : "none",
                  cursor: "pointer",
                  paddingBottom: "5px"
                }}
              >
                Todos
              </h6>
            </div>

            <div className="card-body">
              <div className="table-responsive">
                <table className="table table-striped table-sm table-bordered align-baseline" style={{ width: "100%", fontFamily: "poppins" }}>
                  <thead>
                    <tr>
                      <th>S.No</th>
                      <th>Icone</th>
                      <th>Title</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Category.map((Cat, index) => (
                      <tr key={Cat.id}>
                        <td>{(currentPage - 1) * unitsPerPage + index + 1}</td>
                        <td>
                          <img src={`http://193.203.162.101:8002${Cat.icon}`} alt='icone' className='me-3' style={{ width: "50px" }} />

                        </td>
                        <td >
                          {Cat.title}
                        </td>
                        <td>
                          <img
                            src='/assets/images/icons/edit.png'
                            onClick={() => openCategoryModal(Cat)}
                            height={"20px"}
                            alt="Edit"
                          />
                          <img
                            src='/assets/images/icons/delete.png'
                            className="mx-1"
                            onClick={() => handleDeleteCategoryModal(Cat.id)}
                            height={"20px"}
                            alt="Delete"
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          :
          <div className="card">
            <div className="text-center mt-3 mb-3" style={{ display: "flex", justifyContent: "center", gap: "30px" }}>
              <h6
                onClick={() => setTablename(2)}
                style={{
                  borderBottom: Tablename === 2 ? "3px solid blue" : "none",
                  cursor: "pointer",
                  paddingBottom: "5px"
                }}
              >
                Category
              </h6>

              <h6
                onClick={() => setTablename(1)}
                style={{
                  borderBottom: Tablename === 1 ? "3px solid blue" : "none",
                  cursor: "pointer",
                  paddingBottom: "5px"
                }}
              >
                Todos
              </h6>
            </div>

            <div className="card-body">
              <div className="table-responsive">
                <table className="table table-striped table-sm table-bordered align-baseline" style={{ width: "100%", fontFamily: "poppins" }}>
                  <thead>
                    <tr>
                      <th>S.No</th>
                      <th>Title</th>
                      <th>Description</th>
                      <th>Employees</th>
                      {/* <th>Project Title</th> */}
                      <th>Category</th>
                      <th>Start Date</th>
                      <th>End Date</th>
                      {/* <th>Status</th> */}
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Todo.map((Project, index) => (
                      <tr key={Project.id}>
                        <td>{(currentPage - 1) * unitsPerPage + index + 1}</td>
                        <td>{Project.title}</td>
                        <td>{Project.description}</td>
                        <td>{Project.employee_names}</td>
                        {/* <td>{Project.project_title}</td> */}
                        <td>{Project.todo_category_title}</td>
                        <td>{Project.from_date_time}</td>
                        <td>{Project.to_date_time}</td>
                        {/* <td>{Project.status}</td> */}
                        <td>
                          <img
                            src='/assets/images/icons/edit.png'
                            onClick={() => openModal(Project)}
                            height={"20px"}
                            alt="Edit"
                          />
                          <img
                            src='/assets/images/icons/delete.png'
                            className="mx-1"
                            onClick={() => handleDeleteModal(Project.todo_id)}
                            height={"20px"}
                            alt="Delete"
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        }
      </div>

      {deleteModal && (
        <Deletemodel
          setShowModal={showDeleteModal}
          handleDelete={handleDelete}
        />
      )}

      {deleteCategoryModal && (
        <Deletemodel
          setShowModal={showDeleteCategoryModal}
          handleDelete={handleCategoryDelete}
        />
      )}

      {showModal && (
        <TodoForm
          openModal={showModal}
          setOpenModal={setShowModal}
          unit={selectedUnit}
          closeModal={() => setShowModal(false)}
          refreshList={fetchTodos}
        />
      )}

      {showcategoryModal && (
        <ClientForm
          openModal={showcategoryModal}
          setOpenModal={setShowcategoryModal}
          unit={selectedCategory}
          closeModal={() => setShowcategoryModal(false)}
          refreshList={fetchCategory}
        />
      )}
    </div>
  );
};
export default Todolist